/***
*
*   APP LAYOUT
*   Main application layout with navigation
*
**********/

import { Fragment, useContext } from 'react';
import { AuthContext, AppNav, Header } from 'components/lib';
import Style from './app.tailwind.js';

export function AppLayout(props) {

  // context & style
  const context = useContext(AuthContext);

  return (
    <Fragment>
      <AppNav
        type='popup'
        items={[
          { label: 'Dashboard', icon: 'activity', link: '/dashboard' },
          { label: 'Bundle Packaging', icon: 'package', link: '/bundle-packaging' },
          { label: 'Alerts', icon: 'alert-circle', link: '/alerts' },
          { label: 'Feedback', icon: 'heart', link: '/feedback' },
          { label: 'Support', icon: 'help-circle', link: '/support' },
          { label: 'Signup Data', icon: 'bar-chart-2', link: '/signup-promotional-data' },
          // { label: 'Logs', icon: 'clipboard', link: '/logs' },
          // { label: 'Events', icon: 'clock', link: '/events' },
          { label: 'Workspaces', icon: 'credit-card', link: '/workspaces' },
          { label: 'Users', icon: 'users', link: '/users' },
          { label: 'Sign Out', icon: 'log-out', action: context.signout }
        ]}
      />

      <main className={Style.app}>

        <Header title={props.title} />
        {<props.children {...props.data} />}

      </main>
    </Fragment>
  );
}